import { makeStyles } from "@material-ui/core";

export const styles = makeStyles((theme) => ({

    buton: {
      margin: theme.spacing(0.3)
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    bola: {
      display: 'inline-block',
      height: '20px',
      width: '20px',
      // backgroundColor: '#4A90E2',
      background: '#9e9e9e'
    },
    error: {
      background: theme.palette.error.main
    },
    hora: {
      borderRadius: '5%',
      color: theme.palette.common.white,
      background: theme.palette.primary.dark,
      cursor: 'pointer',
      // "&:hover":{
      //   color: theme.palette.common.white,
      //   background: theme.palette.primary.main,
      // }
    }
}));